// START: GitHub Copilot Generated Code
import config from "../config/config";

/**
 * Checks if a language is supported by the application.
 * Intentionally kept in a separate file with no store dependency so that
 * languageSlice.ts can import it without creating a circular reference:
 *   store.ts → languageSlice.ts → languageService.ts → store.ts
 *
 * OWASP Security: Validates language against the configured allowed list.
 *
 * @param language - The language code to validate
 * @returns True if the language is supported, false otherwise
 */
export const isSupportedLanguage = (language: string | null | undefined): boolean => {
    if (!language) return false;
    return config.languageConfig.languages.some((l) => l.name === language);
};
// END: GitHub Copilot Generated Code
